<template>
  <div v-if="showSignUpForm">
    <form-field-full-name
      :entity="registrationForm"
      :validation-errors="validationErrors"
      size=""
    ></form-field-full-name>

    <form-field-input
      label="Email"
      type="email"
      v-model="registrationForm.email_address"
      :validation-errors="validationErrors.email_address"
      size=""
    ></form-field-input>

    <form-field-phone
      v-if="isWebinarSpecial"
      label="Phone Number"
      v-model="registrationForm.phone_number"
      :validation-errors="validationErrors.notifications_phone_number"
      size=""
    ></form-field-phone>

    <div v-else class="columns mt-100">
      <form-field-phone
        label="Phone Number"
        class="column is-6"
        v-model="registrationForm.phone_number"
        :validation-errors="validationErrors.notifications_phone_number"
        size=""
      ></form-field-phone>

      <form-field-input
        label="Coupon"
        class="column is-6"
        v-model="registrationForm.promo_code"
        :validation-errors="validationErrors.promo_code"
        size=""
      ></form-field-input>
    </div>

    <button-default
      class="auth_button"
      :loading="isRegistering"
      :disabled="isRegistering"
      @click="formSubmit"
      size=""
    >Continue</button-default>
  </div>

  <div v-else>
    <div class="verify-message">
      <p>Please check your email and click Verify Email in the message we just sent to {{ registrationForm.email_address }} (<a @click="returnToSignUpForm" class="is-link">wrong email?</a>)</p>
      <p>Once your email is verified we'll get your account fully set up so you can take full advantage of Forefront.</p>
      <p class="subtitle is-5 has-text-centered">30 Day Money Back Guarantee</p>
    </div>
  </div>
</template>

<script>
import auth from "../../../api/auth";
import {ENUMS} from "../../../services/enums";
import dates from "../../../services/dates";
import utils from "../../../services/utils";

export default {
  name: "RegistrationForm",
  props: {
    closedAccountId: {
      type: Number,
      default: null
    },
    billingSpecial: {
      type: Number,
      default: null
    },
    billingPlan: Number,
    billingCycle: Number,
    couponCode: {
      type: String,
      default: '',
    },
    promoCode: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      registrationForm: {
        first_name: '',
        last_name: '',
        email_address: '',
        phone_number: '',
        billing_plan: this.billingPlan,
        billing_cycle: this.billingCycle,
        billing_special: this.billingSpecial,
        coupon_code: this.couponCode,
        promo_code: this.promoCode,
        affiliate_id: null,
      },
      validationErrors: {},
      isRegistering: false,
      showSignUpForm: true,
    }
  },
  created() {
    const affiliateId = this.$utils.getCookie('_fprom_ref');
    if (affiliateId) this.registrationForm.affiliateId = affiliateId;
  },
  computed: {
    isWebinarSpecial() {
      const couponCode = utils.findEnumByValue(this.couponCode, ENUMS.CouponCodeEnum)

      return !!couponCode
    }
  },
  methods: {
    formSubmit() {
      if(this.couponCode === 'webinar-special-one-year' && dates.isInFuture('2021-05-21 21:00')) {
        this.$buefy.snackbar.open({
          message: 'The webinar special is closed, please visit forefrontcrm.com/pricing for current pricing',
          type: 'is-danger',
          position: 'is-bottom',
          indefinite: true
        });
      }

      this.isRegistering = true;

      auth.verifyEmail(this.registrationForm).then(() => {
        this.validationErrors = {};
        this.showSignUpForm = false;
        this.$emit('showSignUpForm')
      }, (error) => {
        if (error.response.status === 422) this.validationErrors = error.response.data.errors;
      }).finally(() => {
        this.isRegistering = false;
      });
    },
    returnToSignUpForm() {
      setTimeout(() => {
        this.showSignUpForm = true;
      }, 200);
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";
.verify-message {
  margin-top: 0.5rem;

  p {
    margin-bottom: 1rem;
    line-height: 1.4;
  }
  .subtitle {
    color: $text-muted;
  }
}
</style>
